import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { CategoryService } from '../header/service/category.service';
import { NgbCarouselConfig, NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../environments/environment';
  declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit, AfterViewInit  {
  public categories: any = [];
  @ViewChild('carousel', { static: true }) carousel: NgbCarousel;
  constructor(private categoryService: CategoryService) { }
  isLoaded = false;
    ngAfterViewInit(): void {
    // Initialize Slick Carousel
   
    }
  
  initializeSlider()
  {
     setTimeout(() => {
      $('.slick-carousel').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }, 0);
  }
  ngOnInit(): void {

    this.categoryService.getCategories().subscribe(res => {

      this.categories = res;
      this.categories.forEach(element => {
        element.categoryImage = environment.globalImagePath + 'CategoryImage/' + element.categoryImage;
      });
      this.isLoaded = true;
      this.initializeSlider();
    });
  }
  

}
